module.exports = __webpack_public_path__ + "assets/img/steak_active.285e18c3.png";